/* import __COLOCATED_TEMPLATE__ from './saved-message-edit-form.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';

/**
 * Shared form component for creating/modifying a saved message
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: '',

  /**
   * Text to be displayed for the canel button
   */
  cancelButtonText: 'Cancel',

  /**
   * Value of the new title text
   */
  newTitle: '',

  /**
   * Value of the new body text
   */
  newBody: '',

  /**
   * True if the form is currently being submitted
   */
  submitting: false,

  /**
   * @param {function}
   */
  onCancelForm: undefined,

  /**
   * True if the form should be disabled.
   *
   * @type {Boolean}
   */
  disableSubmit: computed('newTitle', 'newBody', 'submitting', function() {
    if (this.get('submitting')) return true;
    if (!this.get('newTitle')) return true;
    if (!this.get('newBody')) return true;
    return false;
  }),

  init() {
    this._super(...arguments);
    this._handleSubmitError = this._handleSubmitError.bind(this);
    this.set('errors', {});
  },

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when the user clicks on the cancel call-to-action
     */
    cancelForm() {
      this.onCancelForm();
    },

    clearErrorOnChange(id) {
      this.set(`errors.${id}`, undefined);
    },

    /**
     * Action called when the user submits the form
     */
    submitForm() {
      this.set('errors', {});
      this.set('submitting', true);
      this._handleSubmit().catch(this._handleSubmitError);
    },
  },

  /**
   * @inheritDoc
   */
  didInsertElement() {
    this._super(...arguments);
    document.getElementById('edit-message-title').focus();
  },

  /**
   * @returns {Promise<any>}
   * @private
   */
  _handleSubmit() {
    throw new Error('SavedMessageEditForm::handleSubmit() not implemented');
  },

  /**
   *
   * @param {Error} e
   * @private
   */
  _handleSubmitError(e) {
    this.set('submitting', false);
    handleErrorResponse(this, e, ['title', 'body']);
  },
});
